import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useContext, useState } from "react";
import { queryClient } from "../../api/requestProcessor";
import { useMutation } from "@tanstack/react-query";
import { AppContext } from "../../context/AppProvider";
import { updateDailyReport } from "../../api/dailyReportsAPI";
import { getErrorMessage } from "../../util/helper";
import { InputTextarea } from "primereact/inputtextarea";

export default function NewNoteDialog({
  isVisible,
  hideDialog,
  dailyReport,
  setDailyReport,
}) {
  const { toast } = useContext(AppContext);

  const [newNote, setNewNote] = useState({
    note: "",
  });

  const { mutate: updateDailyReportMutation, isPending: isPendingUpdate } =
    useMutation({
      mutationFn: updateDailyReport,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["daily-report"] });
        hideDialog();
        setNewNote({
          note: "",
        });
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Note added to the daily report",
          life: 3000,
        });
      },
      onError: (error) => {
        toast.current.show({
          severity: "Error",
          summary: "Error",
          detail: getErrorMessage(error),
          life: 3000,
        });
      },
    });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewNote((prevNewNote) => ({
      ...prevNewNote,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleUpdateDailyReport = () => {
    let _dailyReport = { ...dailyReport };
    _dailyReport.notes = [..._dailyReport.notes, newNote];

    setDailyReport(_dailyReport);
    updateDailyReportMutation({
      dailyReport: { notes: _dailyReport.notes },
      dailyReportId: _dailyReport._id,
    });
  };

  const dialogFooter = (
    <>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label={isPendingUpdate ? "Creating" : "Create"}
        icon="pi pi-check"
        onClick={handleUpdateDailyReport}
        loading={isPendingUpdate}
      />
    </>
  );

  return (
    <Dialog
      visible={isVisible}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header="Note Details"
      modal
      className="p-fluid mx-2"
      footer={dialogFooter}
      onHide={hideDialog}
    >
      <div className="field">
        <label htmlFor="note" className="font-bold">
          Note
        </label>
        <InputTextarea
          id="note"
          name="note"
          value={newNote.note}
          onChange={handleChange}
          required
        />
      </div>
    </Dialog>
  );
}
